import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import If from 'src/components/Shared/If/If';
import Phone from 'src/components/Shared/Phone/Phone';
import { setProgress as actionSetProgress } from 'src/redux/modules/progress';
import { getUncollectedSharesLookup } from 'src/redux/modules/sellUncollectedShares/selectors';
import {
  APP_TOLL_FREE_NUMBER,
  FundNoteExchange,
  FundNoteRothConversion,
} from 'src/settings/settings';
import FundNote from './FundNote';
import './FundNote.module.scss';
import PendingTransactionFundNoteTip from './PendingTransactionFundNoteTip';
import config from '../../../../config/config';

const RothConversionFundNotes = ({ fund }) => {
  return (
    <Fragment>
      <If
        test={fund.notes[FundNoteRothConversion.MONEY_MARKET_EVENT_GATE_ACTIVE]}
      >
        <FundNote
          labelSubText={
            <div
              dangerouslySetInnerHTML={{
                __html: fund.moneyMarketReformMessage,
              }}
              className="exclude"
            />
          }
          labelText="Redemption Block"
          showToolTip={false}
        />
      </If>
      <If
        test={
          fund.notes[FundNoteRothConversion.MONEY_MARKET_EVENT_GATE_REMOVED]
        }
      >
        <FundNote
          labelSubText={
            <div
              dangerouslySetInnerHTML={{
                __html: fund.moneyMarketReformMessage,
              }}
              className="exclude"
            />
          }
          labelText="Redemption Block Removed"
          showToolTip={false}
        />
      </If>
      <If
        test={fund.notes[FundNoteRothConversion.MONEY_MARKET_EVENT_FEE_ACTIVE]}
      >
        <FundNote
          labelSubText={
            <div
              dangerouslySetInnerHTML={{
                __html: fund.moneyMarketReformMessage,
              }}
              className="exclude"
            />
          }
          labelText="Liquidity Fee"
          showToolTip={false}
        />
      </If>
      <If
        test={fund.notes[FundNoteRothConversion.MONEY_MARKET_EVENT_FEE_REMOVED]}
      >
        <FundNote
          labelSubText={
            <div
              dangerouslySetInnerHTML={{
                __html: fund.moneyMarketReformMessage,
              }}
              className="exclude"
            />
          }
          labelText="Liquidity Fee Removed"
          showToolTip={false}
        />
      </If>
      <If test={fund.notes[FundNoteRothConversion.STOP_TRANSFER]}>
        <FundNote
          labelSubText=""
          labelText="Stop Transfer"
          tipHeader="Stop Transfer"
          tipMessage={
            <div className="exclude">
              A stop transfer has been applied to this fund. Call{' '}
              <Phone phoneNumber="(877) 495-8459" /> to redeem from this fund.
            </div>
          }
        />
      </If>
      <If
        test={
          fund.notes[FundNoteRothConversion.AUTOMATED_SYSTEMS_STOP_REDEMPTION]
        }
      >
        <FundNote
          labelSubText=""
          labelText="Unavailable Online"
          tipHeader="Unavailable Online"
          tipMessage={
            <div className="exclude">
              Online/phone redemption disabled.{' '}
              <a
                href={`${config.url}/personal-investing/help/contact/index.html`}
                rel="noopener noreferrer"
                target="_blank"
              >
                Contact us
              </a>{' '}
              to enable redemptions.
            </div>
          }
        />
      </If>
      <If
        test={
          (fund.notes[FundNoteExchange.STOP_PURCHASE] ||
            fund.notes[FundNoteExchange.AUTOMATED_SYSTEMS_STOP_ALL]) &&
          fund.productType === 'ManagedAccount'
        }
      >
        <FundNote
          labelSubText=""
          labelText="Exchange Unavailable"
          tipHeader="Exchange Unavailable"
          tipMessage={
            <div className="exclude">
              Your account has a feature on it that restricts exchanges. Call{' '}
              <Phone phoneNumber={APP_TOLL_FREE_NUMBER} /> to discuss options
            </div>
          }
        />
      </If>
      <If test={fund.notes[FundNoteRothConversion.PENDING]}>
        <FundNote
          labelSubText=""
          labelText="Transaction Pending"
          tipHeader="Transaction Pending"
          tipMessage={<PendingTransactionFundNoteTip />}
        />
      </If>
      <If test={fund.notes[FundNoteRothConversion.PENDING_TRANSACTION]}>
        <FundNote
          labelSubText=""
          labelText="Transaction Pending"
          tipHeader="Transaction Pending"
          tipMessage={<PendingTransactionFundNoteTip allFunds />}
        />
      </If>
      <If test={fund.notes[FundNoteRothConversion.PENDING_FROM_TRANSACTION]}>
        <FundNote
          labelSubText=""
          labelText="Transaction Pending"
          tipHeader="Transaction Pending"
          tipMessage={<PendingTransactionFundNoteTip />}
        />
      </If>

      <If test={fund.notes[FundNoteRothConversion.EXISTING_ICLASS]}>
        <FundNote
          labelText={'Existing Roth I Class'}
          tipHeader={'Existing Roth I Class'}
          tipMessage={
            <div className="exclude">
              Cross class conversions are unable to be processed online. Please{' '}
              <a
                className="exclude"
                href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                rel="noreferrer"
                target="_blank"
              >
                contact us.
              </a>{' '}
            </div>
          }
        />
      </If>

      <If test={fund.notes[FundNoteRothConversion.ROTH_RECENTLY_REDEEMED]}>
        <FundNote
          labelText={'Roth IRA Recently Redeemed'}
          tipHeader={'Roth IRA Recently Redeemed'}
          tipMessage={
            <div className="exclude">
              The existing Roth IRA invested in this fund/ticker has a 30-day
              purchase block due to recent redemption or exchange greater than
              $5,000.
            </div>
          }
        />
      </If>

      <If test={fund.notes[FundNoteRothConversion.ROTH_STOP_PURCHASE]}>
        <FundNote
          labelSubText=""
          labelText="Stop Purchase on Roth IRA"
          tipHeader="Stop Purchase on Roth IRA"
          tipMessage={
            <div className="exclude">
              The existing Roth IRA invested in this fund/ticker has a Stop
              Purchase applied. Please{' '}
              <a
                className="exclude"
                href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                rel="noreferrer"
                target="_blank"
              >
                contact us
              </a>{' '}
              to discuss options.
            </div>
          }
        />
      </If>

      <If
        test={
          fund.notes[
            FundNoteRothConversion.CONVERSION_RESTRICTED_RETIREMENT_2020
          ]
        }
      >
        <FundNote
          labelSubText=""
          labelText="Conversion Restricted"
          tipHeader="Conversion Restricted"
          tipMessage={
            <div className="exclude">
              Online conversions of this fund are currently restricted. Please{' '}
              <a
                className="college-branded-link exclude"
                href={`${config.url}/personal-investing/help/contact/index.html`}
                rel="noopener noreferrer"
                target="_blank"
              >
                contact us
              </a>{' '}
              to discuss other options.
            </div>
          }
        />
      </If>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  const { sellUncollectedShares } = state;
  return {
    sellUncollectedShares,
    uncollectedSharesLookup: getUncollectedSharesLookup(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setProgress: actionSetProgress,
    },
    dispatch
  );

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  RothConversionFundNotes
);
